<template>
  <div>
    <div  v-if="loadings">
      <skeleton-revenue />
    </div>
    <div class="vuse-content-wrapper mt-4">
      <div>
          <v-row >
            <v-col>
              <h2 class="ml-3">
                {{$t(page+'.Pricelists')}}
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="loadData">
                        <v-icon>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>
            <v-spacer /> 
          </v-row>
          <template v-if="!customers && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5 mt-2">
              <v-col cols="12" md="12" class="mx-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title class="pb-3">
                    <v-row>
                      <v-btn-toggle v-model="selectedArea" @change="search=selectedArea.shippingArea" class="ml-3 mt-3">
                        <template v-for="(c,i) in shippingAreas">
                          <v-tooltip bottom :key="i" max-width="300">
                            <template v-slot:activator="{ on }">
                              <v-btn :key="i" active-class="green" :value="c" v-on="on">
                                <v-div class="float-left">
                                  <v-div>{{c.shippingArea}}</v-div>
                                </v-div>
                              </v-btn>
                            </template>
                            <span>{{c.CountryNames}}</span>
                          </v-tooltip>
                        </template>
                      </v-btn-toggle>
                      <v-spacer></v-spacer>
                      <v-col cols=12 sm="6" lg="2">
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            :label="$t(page+'.Search')"
                            single-line
                            hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col md="2" cols="12" :key="i" class="col-p5 mt-1 text-center">
                        <v-div>
                          <v-tooltip top >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="error"  @click="deleteArea()" v-bind="attrs" v-on="on">
                                <v-icon>fas fa-times-circle</v-icon>
                              </v-btn>
                            </template>
                            <span>{{$t(page+'.Delete Area')}}</span>
                          </v-tooltip>
                        </v-div>
                        <v-div>
                          <v-tooltip top >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="primary"  @click="addArea()" v-bind="attrs" v-on="on">
                                <v-icon>fas fa-plus-circle</v-icon>
                              </v-btn>
                            </template>
                            <span>{{$t(page+'.Add Area')}}</span>
                          </v-tooltip>
                        </v-div>
                        <v-div>
                          <v-tooltip top >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="primary"  @click="addRange()" v-bind="attrs" v-on="on">
                                <v-icon>fas fa-plus-square</v-icon>
                              </v-btn>
                            </template>
                            <span>{{$t(page+'.Add Weight Range')}}</span>
                          </v-tooltip>
                        </v-div>
                        <v-divider vertical></v-divider>
                        <v-btn icon @click="info_dialog=true" class="ml-3">
                          <v-icon color="primary">fas fa-info-circle</v-icon>
                        </v-btn>
                      </v-col> 
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      fixed-header="true"
                      :headers="i18_headers"
                      :items="customers"
                      :items-per-page="Math.floor((wIH - 348-85.95)/4)"
                      :height="wIH - 348"
                      :search="search"
                      class="elevation-1 mx-4"
                      :loading="loading" 
                      loading-text="Loading... Please wait"
                      disable-sort=1
                  >
                  <!--
                    <template #item.index="{ item }">
                      {{ customers.indexOf(item)+1 }}
                    </template>
                    -->

                    <template v-slot:[`item.active`]="{ item }">
                      <v-simple-checkbox color="primary" v-model="item.active" @click="save($event,'active',item)"></v-simple-checkbox>
                    </template>

                    <template v-slot:[`item.area`]="{ item }">
                      <v-div>
                        <i :class="'em em-flag-'+item.area.toLowerCase()" style="width:36px;height:36px"></i>
                      </v-div>
                      <v-div class="ml-2 text-h6">{{item.area}}</v-div>                    
                    </template>

                    <template v-slot:[`item.isCourier`]="{ item }">
                      <v-tooltip top :disabled="item.used==0&&item.pricelistName!='P1'">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" v-on="on">{{item.isCourier==1?'fas fa-shipping-fast':'fas fa-running'}}</v-icon>
                        </template>
                        <span>
                          {{item.isCourier==1?$t(page+'.Courier Service'):$t(page+'.Postal Service')}}
                        </span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.weightFrom`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="weightFrom" 
                      v-model="item.weightFrom" :value="new Intl.NumberFormat(user.locale||'en', {maximumFractionDigits: 0}).format(item.weightFrom/1)"></v-text-field>
                    </template>

                    <template v-slot:[`item.weightTo`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="weightTo" v-model="item.weightTo" 
                      :value="new Intl.NumberFormat(user.locale||'en', {maximumFractionDigits: 0}).format(item.weightTo/1)"></v-text-field>
                    </template>

                    <template v-slot:[`item.salePrice`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="salePrice" :v-model="item.salePrice" :value="formatPrice(item.salePrice)" 
                      background-color="#ff000020"
                      ></v-text-field>
                    </template>

                    <template v-slot:[`item.VWRatio`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="VWRatio" v-model="item.VWRatio" :value="(item.VWRatio/1).toFixed(0)"
                      :hint="$t(page+'.Default')+': '+(item.aVWRatio/1).toFixed(0)"
                      persistent-hint=1
                      background-color="#0000ff20"
                      ></v-text-field>
                    </template>

                    <template v-slot:[`item.minCODFees`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="minCODFees" v-model="item.minCODFees" append-outer-icon="fas fa-euro-sign" 
                      :value="(item.minCODFees/1).toFixed(0)"
                      :hint="$t(page+'.Default')+': '+(item.aMinCODFees/1).toFixed(2)+'€'"
                      persistent-hint=1
                      background-color="#0000ff20"
                      ></v-text-field>
                    </template>

                    <template v-slot:[`item.CODFeesRate`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="variable" v-model="item.CODFeesRate" append-outer-icon="fas fa-percent" 
                      :value="(item.CODFeesRate/1).toFixed(2)"
                      :hint="$t(page+'.Default')+': '+(item.aCODFeesRate/1).toFixed(2)"
                      persistent-hint=1
                      background-color="#0000ff20"
                      ></v-text-field>
                    </template>

                    <template v-slot:[`item.minInsuranceFees`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="minInsuranceFees" v-model="item.minInsuranceFees" append-outer-icon="fas fa-euro-sign" 
                      :value="(item.minInsuranceFees/1).toFixed(0)"
                      :hint="$t(page+'.Default')+': '+(item.aMinInsuranceFees/1).toFixed(2)+'€'"
                      persistent-hint=1
                      background-color="#0000ff20"
                      ></v-text-field>
                    </template>

                    <template v-slot:[`item.insuranceFeesRate`]="{ item }">
                      <v-text-field outlined dense @input.native="save" :id="item.pricelistId" class="text-subtitle-1 slim" filled reverse name="insuranceFeesRate" v-model="item.insuranceFeesRate" append-outer-icon="fas fa-percent" 
                      :value="(item.insuranceFeesRate/1).toFixed(2)"
                      :hint="$t(page+'.Default')+': '+(item.aInsuranceFeesRate/1).toFixed(2)"
                      persistent-hint=1
                      background-color="#0000ff20"
                      ></v-text-field>
                    </template>

                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="addArea_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Add Area Pricelist')}}</v-card-title
        >
        <v-row class="mx-5 mb-10">
          <v-col md="4" cols="12" class="pt-7">
            {{$t(page+'.Enter Area Code')}}
          </v-col>  
          <v-col md="8" cols="12">
            <v-select
              name="newArea"
              dense
              clearable
              outlined
              :items="freeShippingAreas"
              v-model="newArea"
              :label="$t(page+'.New Area')"
              :hint="$t(page+'.Enter a 2 Letter Country Code or an Area Code created in Countries')"
            ></v-select>
          </v-col> 
          <v-col md="4" cols="12" class="pt-7">
            {{$t(page+'.Select the area you want to copy prices/values')}}
          </v-col> 
          <v-col md="8" cols="12" class="pt-6">
            <v-select
              name="copyArea"
              dense
              clearable
              outlined
              :items="shippingAreas"
              v-model="copyArea"
              :label="$t(page+'.Copy Data from')+'...'"
              :hint="$t(page+'.unselect if want to enter manually')"
            ></v-select>
          </v-col>           
        </v-row>
        <v-card-actions>
          <v-btn color="primary"  @click="addArea_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip top max-width="300">
            <template v-slot:activator="{ on }">     
              <v-btn color="primary" v-on="on" @click="addArea2()">
                {{$t(page+'.Create')}}
              </v-btn>
            </template>
            <span>{{$t(page+'.CreateAreaHints')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeArea_dialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Remove Area Pricelist')}}</v-card-title
        >
        <v-row class="mx-5 mb-10">
          <v-col md="6" cols="12" class="pt-7">
            {{$t(page+'.Select Area to Remove')}}
          </v-col>  
          <v-col md="6" cols="12">
            <v-select
              name="newArea"
              dense
              clearable
              outlined
              :items="shippingAreas.filter(e=> e.shippingArea!='IT')"
              v-model="newArea"
              :label="$t(page+'.Select Area to Remove')"
            ></v-select>
          </v-col>          
        </v-row>
        <v-card-actions>
          <v-btn color="primary"  @click="removeArea_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip top max-width="300">
            <template v-slot:activator="{ on }">     
              <v-btn color="primary" v-on="on" @click="deleteArea2()">
                {{$t(page+'.Delete')}}
              </v-btn>
            </template>
            <span>{{$t(page+'.DeleteAreaHints')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addWeightRange_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Add Weight Range')}}</v-card-title
        >
        <v-row class="mx-5 mb-10">
          <v-col md="4" cols="12" class="pt-7">
            {{$t(page+'.Enter Range Boundaries')}}
          </v-col>  
          <v-col md="4" cols="12">
            <v-text-field
              outlined
              v-model="newFrom"
              :label="$t(page+'.From')"
              hint="in gr."
              persistent-hint
              type="number"
            ></v-text-field>
          </v-col> 
          <v-col md="4" cols="12">
            <v-text-field
              v-model="newTo"
              :label="$t(page+'.To')"
              hint="in gr."
              persistent-hint
              outlined
              type="number"
            ></v-text-field>
          </v-col> 
          <v-col md="4" offset-md="1" cols="12">
            <v-switch
              v-model="newIsCourier"
              inset
              :append-icon="newIsCourier?'fas fa-shipping-fast':'fas fa-running'"
              :label="newIsCourier?$t(page+'.Courier Service'):$t(page+'.Postal Service')"
            ></v-switch>
          </v-col>          
          <v-col md="6" offset-md="1" cols="12">
            <v-select
              name="onlyArea"
              dense
              clearable
              outlined
              :items="shippingAreas"
              v-model="onlyArea"
              :label="$t(page+'.Only for Area')+'...'"
            ></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary"  @click="addWeightRange_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip top max-width="300">
            <template v-slot:activator="{ on }">     
              <v-btn color="primary" v-on="on" @click="addRange2()">
                {{$t(page+'.Create')}}
              </v-btn>
            </template>
            <span>{{$t(page+'.CreateWeightHints')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="info_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Instructions')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="6" cols="12">
            {{$t(page+'.ShippingDetailsModalInstructions')}}
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="info_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" absolute centered :color="snackbar_color">
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<style scoped>
  .slim .v-input__slot {
    min-height:30px!important;
    max-height:20px!important;
  }
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import _ from 'lodash'

export default {
  components: { NoData, SkeletonRevenue, ExcelIcon },
  computed : {
    ...mapGetters(["user"]),
    formatPrice2: function(price)
    {
      let tmp=price==null?0:Number(price).toFixed(2)
      console.log(468,price,tmp);
      return tmp;
    },
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },
  data() {
    return {
      namespace: "Reports",
      page: "BossPricelists",
      UserID:null,
      username:'',
      msg_modal:false,
      msg:{},
      newIsCourier:true,
      loading: true,
      errorid: null,
      simulation:5,
      search: '',
      wIH:window.innerHeight,      
      shippingAreas:[],
      freeShippingAreas:[],
      customers: [],
      info_dialog:0,
      addArea_dialog:0,
      removeArea_dialog:0,
      addWeightRange_dialog:0,
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      headers: [
          //{ text: 'Active', value: 'active',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'Area', value: 'area',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'Class', value: 'isCourier',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'From gr', value: 'weightFrom',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1' },
          { text: 'To gr', value: 'weightTo',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1' },
          { text: 'Price', value: 'salePrice',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1' },
          { text: 'COD Fees Rate', value: 'CODFeesRate',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'Min COD Fees', value: 'minCODFees',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'Insurance Fees Rate', value: 'insuranceFeesRate',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'Min Insurance Fees', value: 'minInsuranceFees',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1'},
          { text: 'VWRatio', value: 'VWRatio',align: 'center', class : 'text-subtitle-2 font-weight-black primary--text py-1' },
        ],      
    };
  },
  created(){
    this.loadData()
  },
  methods:
  {
    formatPrice(price)
    {
      let tmp=price==null?0:Number(price).toFixed(2)
      //console.log(468,price,tmp);
      return tmp;
    },
    addArea(){
      this.addArea_dialog=1;
    },
    addArea2(){
      this.addArea_dialog=1;
      console.log(370,this.newArea,this.copyArea)
      let payload={"action":"add_pricelist","payload":{"action":"add","newArea":this.newArea,"copyFrom":this.copyArea}};
      this.update_db(payload)
    },
    deleteArea(){
      this.removeArea_dialog=1;
    },
    deleteArea2(){
      this.removeArea_dialog=1;
      console.log(386,this.newArea)
      let payload={"action":"add_pricelist","payload":{"action":"delete","newArea":this.newArea}};
      this.update_db(payload)
    },   
    addRange(){
      this.addWeightRange_dialog=1;
    },
    addRange2(){
      console.log(370,this.newFrom,this.newTo,this.newIsCourier,this.onlyArea);
      let payload={"action":"edit_pricelist_add_pricerange","payload":{"table":"Pricelist","newFrom":this.newFrom,"newTo":this.newTo,"isCourier":this.newIsCourier,"onlyArea":this.onlyArea}};
      this.update_db(payload)
      //this.customers.unshift(zz);
    },
    save: _.debounce(function (event,id='',field='') {
        this.formReadOnly=true;
        console.log(216,event,id,field);
        let payload=''
        if (field=='')
        {
          console.log(383);
          payload={"action":"edit_pricelist","payload":{"table":"Pricelist","field":event.target.name,"value":event.target.value,"key":"pricelistId","keyValue":event.target.id}};
        }
        else
        {
          console.log(388);
          payload={"action":"edit_pricelist","payload":{"table":"Pricelist","field":field,"value":event==false?0:1,"key":"pricelistId","keyValue":id}};
        }
        console.log(226,payload)
        this.update_db(payload)
        //this.updateDB(event.target.name,event.target.value)
    }, 1000), 
    async update_db(payload){
      let jwt=sessionStorage.getItem('jwt');
      try{
          console.log(232,payload);
          
          const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':payload});
          console.log(238,res.data);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(417,payload.payload.value);
              console.log(418,res.data.payload[res.data.payload.field]);
              this.addArea_dialog=false;
              this.removeArea_dialog=false;
              this.addWeightRange_dialog=false;
              this.loadData();
              

              /*
              console.log(252,payload.id,res.data.payload,this.isJson(res.data.payload),this.customers)
              if (res.data.payload!='0')
              {
                this.customers.unshift(JSON.parse(res.data.payload));
                console.log(254,this.customers);
              }*/
             break;
          }
          return res.data;
      } 
      catch(e)
      {
        console.log(e);
          this.snackbar_color='red darken-2';
          this.snackbar_text='Connection Error - Try Later';
      }
      this.snackbar=true;
      return null;
    },
    isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
    },
     openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;

    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try
      {
          const res = await this.$http.post('/boss/pricelists.php', {"jwt":jwt});
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payload.table;
              this.shippingAreas=res.data.payload.shippingAreas;
              this.freeShippingAreas=res.data.payload.freeShippingAreas;
              //console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
    async impersonate(e,p)
    {
      if(p)
      {
        this.loader=true;    
    	  //localStorage.clear();
	      localStorage.removeItem('user');
	      //sessionStorage.clear();
	      sessionStorage.removeItem('jwt');
        try
        {
          const res = await this.$http.post('/auth/login.php', {email: e, password: p, rememberme: true})
          this.errorid=res.data.errorid;
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            res.data.user.jwt=res.data.jwt;
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setFixings", res.data.fixings);
            //this.$store.dispatch("setLocale", res.data.user.locale);
            //this.$store.dispatch("setCurrency", res.data.user.currency);
            //this.$store.dispatch("set_timeframe", res.data.user.timeframe); 
            
            if (res.data.ls_user)
            {
              localStorage.setItem('user', JSON.stringify(res.data.ls_user));
              //localStorage.setItem('user', res.data.user);
            }
            else
            {
              localStorage.removeItem('user');
            }
            this.$router.push('/'+res.data.user.landingpage).catch(() => {});
          }
          else
          {
            this.message=res.data.message;
            this.dialog=true;
          }
        }       
        catch(e)
        {
          this.$router.push('/auth/login').catch(() => {});
        }
        this.loader=false;
      }
      else
      {
        this.snackbar=true;
        this.snackbar_text='Missing PWD';
        this.snackbar_color='red';
      }
    },
  }
};
</script>